import { useEffect, useState } from "react";

// Subscribe to a CSS media query. Guards against environments without
// window.matchMedia (e.g. jsdom in tests), returning false there so layouts
// fall back to the desktop default and existing tests are unaffected.
export function useMediaQuery(query: string): boolean {
  const read = () =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(query).matches
      : false;

  const [matches, setMatches] = useState<boolean>(read);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange(); // sync in case it changed between render and effect
    mql.addEventListener?.("change", onChange);
    return () => mql.removeEventListener?.("change", onChange);
  }, [query]);

  return matches;
}

// Narrow viewport = phones / small tablets in portrait. Entry forms collapse
// their multi-column grids to a single stacked column at this width.
export function useIsNarrow(): boolean {
  return useMediaQuery("(max-width: 640px)");
}
